/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  /* ------------------------------------------------------------------
     Page produit (mobile) : points de navigation sous la galerie
     Style Impulse — une image par écran, point actif en noir.
     ------------------------------------------------------------------ */
  var MOBILE_MAX = 749;

  function buildDots(gallery) {
    if (!gallery || gallery.dataset.mmDots === '1') return;

    var list = gallery.querySelector('[data-product-media-list]');
    if (!list) return;

    var slides = list.querySelectorAll('.product__slide');
    if (slides.length < 2) return;

    gallery.dataset.mmDots = '1';

    var nav = document.createElement('div');
    nav.className = 'mm-dots';

    var dots = [];

    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mm-dots__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      (function (index) {
        dot.addEventListener('click', function () {
          list.scrollTo({ left: slides[index].offsetLeft - list.offsetLeft, behavior: 'smooth' });
        });
      })(i);
      nav.appendChild(dot);
      dots.push(dot);
    }

    list.parentNode.insertBefore(nav, list.nextSibling);

    var ticking = false;

    function sync() {
      var width = list.clientWidth || 1;
      var index = Math.round(list.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;

      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
      ticking = false;
    }

    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function init() {
    if (window.innerWidth > MOBILE_MAX) return;
    document.querySelectorAll('.product__images--mobile-slider').forEach(buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
